import { _js } from '@ifixit/utils/localize';
import { faBold } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const BoldButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('bold'),
      isDisabled: !editor.can().toggleBold(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBold().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faBold} />}
         /* Translators: Bold, as in the text formatting */
         title={_js('Bold')}
         shortcut={'b'}
      />
   );
};
